
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
const meta = {};
const slug = '_settingup';
const tableOfContents = [{
  "title": "------",
  "slug": "",
  "children": [{
    "title": "Add Products",
    "slug": "add-products",
    "children": []
  }, {
    "title": "Activate Payment gateways",
    "slug": "activate-payment-gateways",
    "children": []
  }, {
    "title": "Activate Shipment options",
    "slug": "activate-shipment-options",
    "children": []
  }, {
    "title": "Add your custom domain",
    "slug": "add-your-custom-domain",
    "children": []
  }]
}];

const layoutProps = {
  meta,
slug,
tableOfContents
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <_Heading level={2} id={""} nextElement={{
      "type": "heading",
      "depth": 3
    }}>------</_Heading>
    <_Heading level={3} id={"add-products"} nextElement={{
      "type": "paragraph"
    }}>Add Products</_Heading>
    <p>{`Write your product title and description. Upload product photos or other media. Set your price, Setup Stocks limit.`}</p>
 <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/add-product-store.png" />
      </div>
    <_Heading level={3} id={"activate-payment-gateways"} nextElement={{
      "type": "paragraph"
    }}>Activate Payment gateways</_Heading>
    <p>{`We support multiple payment gateways. If you are interested in implementing a custom payment gateways, let us know in the contact form.`}</p>
 <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/payment-store.png" />
      </div>
    <_Heading level={3} id={"activate-shipment-options"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Activate Shipment options</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li">{`Pick up at source `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Delivery/Pick up at Storage Points `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Delivery at Destination `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Delivery `}</p>
        <div class="relative">
       <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/shipping-store.png" />
     </div>
      </li>
    </ul>
    <_Heading level={3} id={"add-your-custom-domain"} nextElement={{
      "type": "jsx"
    }}>Add your custom domain</_Heading>
 <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/customdomain-store.png" />
      </div>
    <p>{`Your store is ready to start making money 🚀`}</p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
